import { getCookie } from "../utils/common";
// const sampleDescription =
//   "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vitae urna at est aliquam interdum id eget ex. Donec at arcu dictum, dictum mi vitae, vestibulum ipsum. Nulla at ante consectetur, egestas ante vel, congue libero. Morbi tincidunt dui erat, nec commodo augue rutrum sed. Nullam tincidunt lacus posuere massa maximus congue.";
const strings = {
  Dashboard: {
    en: "Dashboard",
    es: "Tablero",
  },
  Blog: {
    en: "Blog",
    es: "Blog",
  },
  Subscribe:{
    en:"Subscribe"
  },
  Home_IntroHeading: {
    en: "World's first real-time AI Chatter & Sentiment Analyzer, for stock trading.",
    es: "El primer analizador de sentimientos de inteligencia artificial en tiempo real del mundo, para el comercio de acciones.",
  },
  Home_IntroText: {
    en: "We analyze 50,000+ datasources (Twitter, Reddit, News Articles & Blogs) real-time to accurately track the market chatter and sentiment for all the major companies. Access the weekly reports to make the best trading decisions.",
    es: "Analizamos más de 50,000 fuentes de datos (Twitter, Reddit, artículos de noticias y blogs) en tiempo real para rastrear con precisión el sentimiento del mercado para todas las principales empresas. Acceda a los informes semanales para tomar las mejores decisiones comerciales.",
  },
  Home_TrendsHeading: {
    en: "Discover emerging stocks, before they takeoff!",
    es: "¡Descubra las acciones emergentes, antes de que despeguen!",
  },
  View:{
    en:"View",
  },
  LiveSentiment: {
    en: "Live Sentiment",
  },
  SocialMentions: {
    en: "Social Mentions",
  },
  FinancialData: {
    en: "Financial Data",
  },
  LiveNews: {
    en: "Live News",
  },
  Home_LiveSentimentFeatureHeading:{
    en:"Never miss out on a market swing"
  },
  Home_LiveSentimentFeature: {
    en: "Our proprietary algorithm tracks real-time sentiment for all popular stocks. Accurately identify if the overall market is feeling bullish or bearish about a stock and be the first to know about momentum swings! We have you covered for all the important market changes.",
  },
  Home_SocialMentionsFeatureHeading:{
    en:"Discover exploding stocks!"
  },
  Home_SocialMentionsFeature: {
    en: "Ever missed out on a stock rally because you were late to the party! Never again! We constantly keep track of chatter about stocks in social media so that you don’t have to. Be the first to know about trending stocks. Get in at the bottom and ride the wave all the way to the top or short if you think it’s a speculative bubble. Whatever the case maybe, there is money being left out on the table! ",
  },
  Home_FinancialDataFeatureHeading: {
    en: "Only what’s required and nothing more!",
  },
  Home_FinancialDataFeature: {
    en: "We don’t believe in drowning you in financial data or becoming the next finviz. We curate and show only the most relevant financial information to help you make your decision. We also keep an eye out and alert you for unusual changes in metrics such as trading volume, insider trading, options volume etc.",
  },
  Home_LiveNewsFeatureHeading: {
    en: "Be in the know!",
  },
  Home_LiveNewsFeature: {
    en: "Get updated about the latest developments in the market straight from our dashboard. We track intraday news from over 3,000 global news sources including major publications and regional media so that you will be in the know as soon as the story breaks!",
  },
  Home_GetAccessToday:{
    en:"Get access today"
  },
  Home_GetAccessSubText:{
    en:"It only takes a few seconds to subscribe for our free newsletter!"
  },
  TermsOfService:{
    en:"Terms of Service"
  },
  Home_BuiltBy:{
    en:"Website built by"
  }
};

export default function getString(str) {
  let language = getCookie("lang") || "en";
  if (strings[str]) {
    if (strings[str][language]) {
      return strings[str][language];
    } else if (strings[str]["en"]) {
      return strings[str]["en"];
    }
  }
  return str;
}
